import { SocketData } from 'actions/socket/socketReceiveDataAction'
import { MessengerTextMessageComet } from 'api/comet/comet.types'
import { ChatMessage } from 'reducers/messenger/ChatMessengerState'

/**
 * Для чистого формата сообщений для мессенджера:
 * https://developers.wamba.com/comet/mamba_messenger_message__aid_-publish/index.html
 */
export const findSameMessage = (
  array: ChatMessage[],
  currentItem: SocketData<MessengerTextMessageComet>
) => array.find((message) => message.id === currentItem?.content.msgid)
